<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div *ngIf="action == 'create'" class="title">{{ 'DIALOG.PRESET.CREATE_PRESET' | translate }}</div>
                <div *ngIf="action == 'edit'" class="title">{{ 'DIALOG.PRESET.EDIT_PRESET' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm btn-back" (click)="activeModal.dismiss(false)">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="sendData()" [disabled]="form.invalid">
                        <!-- <i class="bi bi-save"></i>  -->
                        {{ 'SEND' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row">

                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}:</label>
                                <ng-select 
                                id="attribute_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attribute_id" 
                                [multiple]="false" 
                                [items]="attributes">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_group_id"> {{ 'PRESET.GROUP_ATTRIBUTE' | translate }}:</label>
                                <ng-select 
                                id="attribute_group_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attribute_group_id" 
                                [multiple]="false" 
                                [items]="attributeGroups">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_value_type"> {{ 'PRESET.TYPE_VALUE_ATTRIBUTES' | translate }}:</label>
                                <ng-select 
                                id="attribute_value_type" 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="translate" 
                                bindValue="id"
                                formControlName="attribute_value_type" 
                                [multiple]="false" 
                                [items]="attributeValueTypes">
                                <ng-template ng-option-tmp let-item="item">
                                    <div title="{{item.translate}}">{{item.translate}}</div>
                                </ng-template>
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group">
                                <label class="filter-label" for="attr_present_type_id"> {{ 'TYPE_ATTRIBUTE' | translate }}:</label>
                                <ng-select 
                                id="attr_present_type_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="translate" 
                                bindValue="id"
                                formControlName="attr_present_type_id" 
                                [multiple]="false" 
                                [items]="attributePresentationTypes">
                                <ng-template ng-option-tmp let-item="item">
                                    <div title="{{item.translate}}">{{item.translate}}</div>
                                </ng-template>
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-12" *ngIf="references.length > 0">
                            <div class="form-group">
                                <label class="filter-label" for="references"> {{ 'REFERENCE.REFERENCES' | translate }}:</label>
                                <ng-select 
                                id="attr_reference_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attr_reference_id" 
                                [multiple]="false" 
                                [items]="references">
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="checkboxes">
                        
                        <div class="row">
<!-- 
                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="is_default">
                                    <label class="form-check-label"> По умолчанию</label>
                                </div>
                            </div> -->

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="mandatory">
                                    <label class="form-check-label"> {{ 'MANDATORY' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="visible">
                                    <label class="form-check-label"> {{ 'VISIBLE' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="readonly">
                                    <label class="form-check-label"> {{ 'READ_ONLY' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="translation">
                                    <label class="form-check-label"> {{ 'MULTILINGUAL' | translate }}</label>
                                </div>
                            </div>
                        </div>
                        <div ngbAccordion>
                            <div ngbAccordionItem="selectors" [collapsed]="true">
                                <div ngbAccordionHeader>
                                    <button ngbAccordionButton type="button" class="btn-accordion-title">
                                        <span style="margin-right: 10px;">Селекторы</span>
                                        <i class="bi bi-arrow-down-up"></i>
                                    </button>
                                </div>
                                <div ngbAccordionCollapse>
                                  <div ngbAccordionBody>
                                    <ng-template>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="form-group">
                                                <label class="filter-label" for="legal_form_id">{{ 'CONDITIONS_FILTER.BOOLEAN_OPERATOR' | translate }}:</label>
                                                <ng-select id="attribute_id" class="custom" notFoundText="Нет данных" bindLabel="name"
                                                     bindValue="id" [multiple]="false" [items]="operatorsForCondition"
                                                    [(ngModel)]="selectedOperatorsForCondition" [ngModelOptions]="{standalone: true}" [clearable]="false" appendTo="body">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>

                                            <div formArrayName="selectors">
            
                                                <div *ngFor="let item of form.get('selectors')['controls']; let i = index;">
            
                                                    <div class="row" [formGroupName]="i">
            
                                                        <div class="col-6">
                                                            <div class="form-group">
                                                                <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}:</label>
                                                                <ng-select id="attribute_id" 
                                                                class="custom" 
                                                                clearAllText="{{ 'CLEAR' | translate }}"
                                                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                                                bindLabel="name" bindValue="id"
                                                                formControlName="attribute_id" 
                                                                [multiple]="false"
                                                                [items]="attributes" 
                                                                groupBy="attribute_group_name"
                                                                appendTo="body">
                                                                </ng-select>
                                                            </div>
                                                        </div>
            
        
                                                        <div [ngClass]="form.get('selectors').value.length > 1 ? 'col-5 form-group' : 'col-6 form-group'">
                                                            <div class="form-group">
                                                                <label class="filter-label" for="legal_form_id"> {{ 'VALUE' | translate }}:</label>
                                                                <tag-input 
                                                                formControlName="value"
                                                                [modelAsStrings]="true" 
                                                                placeholder="{{ 'ADD_VALUE' | translate }}" 
                                                                secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}"
                                                                addOnBlur="true"></tag-input>
                                                            </div>
                                                        </div>
            
                                                        <div class="col-1 remove-filter-field"
                                                            *ngIf="form.get('selectors').value.length > 1">
                                                            <button type="button" class="btn btn-danger"
                                                                (click)="removeAddressField(i)">
                                                                <i class="bi bi-trash"></i>
                                                            </button>
                                                        </div>
            
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row add-filter-field">
                                                <div class="col-4">
                                                    <button type="button" class="btn btn-primary btn-sm" (click)="addSelectorsFields()">
                                                        <i class="bi bi-plus-circle"></i> {{ 'CONDITIONS_FILTER.ADD_FILTER' | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                   
                                        <!-- <div class="form-group">
                                        <textarea class="form-control" type="text" formControlName="selectors"></textarea>
                                        </div>  -->
                                    </ng-template>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div ngbAccordion>
                            <div ngbAccordionItem="validators" [collapsed]="true">
                                <div ngbAccordionHeader>
                                    <button ngbAccordionButton type="button" class="btn-accordion-title">
                                        <span style="margin-right: 10px;">{{ 'VALID' | translate }}</span>
                                        <i class="bi bi-arrow-down-up"></i>
                                    </button>
                                </div>
                                <div ngbAccordionCollapse>
                                  <div ngbAccordionBody>
                                    <ng-template>
                                        <div class="form-group">

                                            <!-- <textarea class="form-control" type="text" formControlName="selectors"></textarea> -->
                                        </div>
                                    </ng-template>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>